import { connect } from 'react-redux'
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import { closeModalFranchise } from '../../../actions/purchaseActions'
import { formatURL } from '../../../utils';

export class ModalFranchise extends Component {
    constructor(props) {
        super(props)

        this.goToSearchPage = this.goToSearchPage.bind(this);
        this.covidCoverage = false;
    }

    goToSearchPage() {
        const location = {
            pathname: formatURL(
                this.props.match.params,
                `/pesquisa/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`,
                window.location.search
            ),
        }

        this.props.closeModalFranchise();
        this.props.history.push(location);
    }

    render() {
        if (!this.props.isModalFranchiseActive || this.props.errorsModalFranchise)
            return <div />

        const benefits = this.props.rawProductCoverage

        let franchise = benefits.filter(
            benefit => benefit.code === '500'
        )

        franchise = franchise.length && franchise[0]


        return (
            <div className="comp_modalpagamento quotationDateWarning-modal franchise-modal" onClick={this.props.closeModalFranchise}>
                <div className="modalcontents" onClick={e => e.stopPropagation()}>
                    <div onClick={this.props.closeModalFranchise} className="close-btn"> &times; </div>
                    <div className="contents">
                        <div className="modalmiddle">
                            <h3>Confirma o seguro viagem com franquia?</h3>

                            <p className="text-middle">
                            O seguro viagem escolhido é uma excelente opção, mas atenção, para
                            acionar Despesas Médicas Hospitalares (DMH) existe uma franquia de {franchise.coverage}. Os demais benefícios estão isentos de franquia.
                            </p>

                        </div>
                        <div className="choosecontainer">
                            <div className="optionone">
                                <button className="button" onClick={this.goToSearchPage}>
                                    <span>Voltar à pesquisa</span>
                                </button>
                            </div>
                        </div>
                        <div className="choosecontainer continue">
                            <div className="optionone">
                                <button className="button" onClick={this.props.closeModalFranchise}>
                                    <span>Continuar</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        benefits: state.purchase.benefits_list,
        rawProductCoverage: state.coverage.rawProductCoverage,
        isModalFranchiseActive: state.purchase.isModalFranchiseActive,
        errorsModalFranchise: state.purchase.errors.errorsModalFranchise,
        plan: state.purchase.plans
    }),
    {
        closeModalFranchise
    }
)(withRouter(ModalFranchise));



// WEBPACK FOOTER //
// ./src/components/purchase/modal_franchise/ModalFranchise.jsx